import { useQuery, useMutation } from "react-query";
import { getAllRoles } from "../api-services/roles";

const rolesKey = 'roles';

const useGetAllRoles = params => {
    const response  = useQuery({
        queryKey: [rolesKey, params],
        queryFn: () => getAllRoles(params),
        keepPreviousData: true
    })

    return response; 
}

export { useGetAllRoles };